(function(angular){
	'use strict';

	angular
		.module('planModule')
		.factory('PlanCardFactory', [
			'APP_BASE_PATH',
			'STATIC_BASE_PATH',
			PlanCardFactoryFunction
		]);

	function PlanCardFactoryFunction(
		APP_BASE_PATH,
		STATIC_BASE_PATH) {

		var planCardData = {
			'Starter Portfolio' : {
				title: 'Starter Plan',
				subtitle: 'Now it&rsquo;s easier than<br> ever to try Fundrise.',
				imageUrl: STATIC_BASE_PATH + '/images/marketing/ria/plan-card-starter.jpg',
				slug: '/starter-plan',
				icon: 'starter-portfolio',
				iconLg: 'starter-portfolio-lg'
			},
			'Supplemental Income' : {
				title: 'Supplemental Income',
				subtitle: 'Create an attractive, <br> consistent income&nbsp;stream.',
				imageUrl: STATIC_BASE_PATH + '/images/marketing/ria/plan-card-supplemental-income-2.jpg',
				slug: '/advanced-plans/supplemental-income',
				icon: 'supplemental-income',
				iconLg: 'supplemental-income-lg'
			},
			'Balanced Investing' : {
				title: 'Balanced Investing',
				subtitle: 'Build wealth confidently <br> with high&nbsp;diversification.',
				imageUrl: STATIC_BASE_PATH + '/images/marketing/ria/plan-card-balanced-investing.jpg',
				slug: '/advanced-plans/balanced-investing',
				icon: 'balanced-investing',
				iconLg: 'balanced-investing-lg'
			},
			'Long-Term Growth' : {
				title: 'Long-Term Growth',
				subtitle: 'Pursue superior overall <br> returns over the long&nbsp;term.',
				imageUrl: STATIC_BASE_PATH + '/images/marketing/ria/plan-card-long-term-growth-3.jpg',
				slug: '/advanced-plans/long-term-growth',
				icon: 'long-term-growth',
				iconLg: 'long-term-growth-lg'
			}
		};
		
		var factory = {
			getPlanCardData: getPlanCardData,
			getPlanCtaState: getPlanCtaState,
			getPlanCtaDataFromState: getPlanCtaDataFromState,
			getUrl: getUrl
		};

		return factory;

		function getPlanCardData() {
			return planCardData;
		}

		function getUrl(planName, ctaBaseUrl) {
			var url = APP_BASE_PATH + ctaBaseUrl + planCardData[planName].slug;

			return url;
		}

		function getPlanCtaState(riaPlanName, funnel, authenticated, existingInvestor){
			var ctaState;
			
			if (riaPlanName === 'Starter Portfolio' && funnel === 'starterUpgrade') {
				ctaState = 'starterOnUpgradeView';
			} else if (riaPlanName === 'Starter Portfolio') {
				ctaState = 'starterNotUpgrade';
			} else if (funnel === 'marketing') {
				ctaState = 'marketingFunnelView';
			} else if (funnel === 'direct') {
				ctaState = 'directFunnelView';
			} else if (authenticated && existingInvestor && riaPlanName && riaPlanName !== '') {
				ctaState = 'authenticatedWithPlanSelection';
			} else if (authenticated && existingInvestor) {
				ctaState = 'authenticatedNoPlanSelection';
			} else {
				ctaState = 'defaultView';
			}
			
			return ctaState;
		}
		
		function getPlanCtaDataFromState(state, selectedPlan, investmentEntityId, investmentEntityType) {
			var planCtaData = {
				starterOnUpgradeView: {
					text: 'Select'
				},
				starterNotUpgrade: {
					text: 'Upgrade', 
					link: APP_BASE_PATH + '/account/upgrade/core'
				},
				marketingFunnelView: {
					text: 'View details',
					link: getUrl(selectedPlan, '/start-investing')
				},
				directFunnelView: {
					text: 'View details',
					link: getUrl(selectedPlan, '/investments')
				},
				authenticatedWithPlanSelection: {
					text: 'Select this plan',
					link: APP_BASE_PATH + '/account/investment-accounts/' + investmentEntityId + '/' + investmentEntityType + '/investment-goal/manage'
				},
				authenticatedNoPlanSelection: {
					text: 'Upgrade to 2.0',
					link: APP_BASE_PATH + '/existing/onboarding'
				},
				defaultView: {
					text: 'Invest now'
				}
			};
			
			return planCtaData[state];
		}
	}
})(window.angular);